import { render, staticRenderFns } from "./allAgents.vue?vue&type=template&id=60f9e88c&"
import script from "./allAgents.vue?vue&type=script&lang=js&"
export * from "./allAgents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports